// components/legal/LegalDocumentViewer.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import renderUtils from '../../helpers/renderUtils';
import utils from '../../helpers/utils';
import { useFetchObject } from '../../components/hook/useFetchObject';
import DivBetween from '../../components/div/DivBetween';
import CustomCard from '../../components/CustomCard';
import { FaDownload } from 'react-icons/fa';

const LegalDocumentViewer = ({ isPublic = false, container: Container, card: Card }) => {
  const { type, id } = useParams();

  const typesMapping = {
    regulamin: 'TERMS_OF_SERVICE',
    'polityka-prywatnosci': 'PRIVACY_POLICY',
    'zasady-anulowania-rezerwacji': 'CANCELLATION_POLICY'
  };

  const code = id ? null : typesMapping[type];
  const fetchUrl = id
    ? `${isPublic ? '/public' : ''}/legal-document/${id}`
    : `${isPublic ? '/public' : ''}/legal-document/actual/${code}`;

  const { data: legalDocument, ready } = useFetchObject(fetchUrl, [type, id]);

  const title = renderUtils.renderEnumName(
    legalDocument?.code ?? code,
    'enums/legalDocumentCode'
  );

  const [fileUrl, setFileUrl] = useState(null);
  const [filename, setFilename] = useState(null);

  useEffect(() => {
    if (legalDocument?.file?.filePath) {
      const fullPath = utils.defaultUrl() + legalDocument.file.filePath;
      const fileName = `${type || legalDocument.code?.toLowerCase()}-${legalDocument.version}.pdf`;

      fetch(fullPath)
        .then((res) => res.blob())
        .then((blob) => {
          setFileUrl(URL.createObjectURL(blob));
          setFilename(fileName);
        });
    }
  }, [legalDocument, type]);

  const content = (
    <>
      <DivBetween className={Card ? 'mb-3' : ''}>
        {title}
        {fileUrl && (
          <a
            href={fileUrl}
            download={filename}
            className="btn btn-outline-secondary"
          >
            <FaDownload /> Pobierz dokument
          </a>
        )}
      </DivBetween>

      {!ready ? (
        <p>Ładowanie dokumentu...</p>
      ) : legalDocument ? (
        <CustomCard
          shadow={false}
          title={
            <h5>
              Wersja: {legalDocument.version}
              {legalDocument.lastModifiedDate && <>
                | Ostatnia aktualizacja:{' '}
                {new Date(legalDocument.lastModifiedDate).toLocaleDateString()}
              </>}
            </h5>
          }
        >
          {fileUrl ? (
            <iframe
              src={fileUrl}
              width="100%"
              height="800px"
              title={title}
            />
          ) : (
            <p className="text-danger">Brak za\u0142\u0105czonego pliku PDF.</p>
          )}
        </CustomCard>
      ) : (
        <p className="text-danger">Nie znaleziono dokumentu.</p>
      )}
    </>
  );

  return Container ? <Container title={title}>{content}</Container> : Card ?
    <CustomCard title={title}>{content}</CustomCard> : content;
};

export default LegalDocumentViewer;
